import {
  connectBaseApi,
  driverOnShiftClient,
  createRpcQuery,
  createRpcMutation,
  ConnectProto,
} from "@racoon/api";

const driverOnShiftGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listDriverOnShift: createRpcQuery(build, driverOnShiftClient, "listDriverOnShift", {
      providesTags: (result) =>
        result?.driverOnShifts
          ? [
              ...result.driverOnShifts.map((s: ConnectProto.DriverOnShift) => ({
                type: "DriverOnShift" as const,
                id: String(s.id),
              })),
              { type: "DriverOnShift" as const, id: "LIST" },
            ]
          : [{ type: "DriverOnShift" as const, id: "LIST" }],
    }),
    listTruckDriverOnShifts: createRpcQuery(build, driverOnShiftClient, "listTruckDriverOnShifts", {
      providesTags: (result) =>
        result?.truckDriverOnShifts
          ? [
              ...result.truckDriverOnShifts.flatMap((t: ConnectProto.TruckDriverOnShift) =>
                (t.driverOnShifts || []).map((s: ConnectProto.DriverOnShift) => ({
                  type: "DriverOnShift" as const,
                  id: String(s.id),
                })),
              ),
              { type: "DriverOnShift" as const, id: "LIST" },
            ]
          : [{ type: "DriverOnShift" as const, id: "LIST" }],
    }),
    createDriverOnShift: createRpcMutation(build, driverOnShiftClient, "createDriverOnShift", {
      invalidatesTags: [
        { type: "DriverOnShift", id: "LIST" },
        { type: "Truck", id: "LIST" },
      ],
    }),
    updateDriverOnShift: createRpcMutation(build, driverOnShiftClient, "updateDriverOnShift", {
      invalidatesTags: [
        { type: "DriverOnShift", id: "LIST" },
        { type: "Truck", id: "LIST" },
      ],
    }),
    completeDriverOnShift: createRpcMutation(build, driverOnShiftClient, "completeDriverOnShift", {
      invalidatesTags: [
        { type: "DriverOnShift", id: "LIST" },
        { type: "Truck", id: "LIST" },
      ],
    }),
    forceCompleteDriverOnShift: createRpcMutation(
      build,
      driverOnShiftClient,
      "forceCompleteDriverOnShift",
      {
        // Routes close and jobs change hands or return to the pool, so every
        // list showing shifts, trucks, routes or jobs reloads.
        invalidatesTags: [
          { type: "DriverOnShift", id: "LIST" },
          { type: "Truck", id: "LIST" },
          "Routes",
          "Route",
          "Order",
        ],
      },
    ),
    cancelDriverOnShift: createRpcMutation(build, driverOnShiftClient, "cancelDriverOnShift", {
      invalidatesTags: [
        { type: "DriverOnShift", id: "LIST" },
        { type: "Truck", id: "LIST" },
      ],
    }),
    approveDriverOnShift: createRpcMutation(build, driverOnShiftClient, "approveDriverOnShift", {
      invalidatesTags: [
        { type: "DriverOnShift", id: "LIST" },
        { type: "Truck", id: "LIST" },
      ],
    }),
    driverOnShiftExists: createRpcQuery(build, driverOnShiftClient, "driverOnShiftExists", {
      providesTags: [{ type: "DriverOnShift", id: "LIST" }],
    }),
    GetDriverOnShiftById: createRpcQuery(build, driverOnShiftClient, "getDriverOnShiftById", {
      providesTags: (_result, _error, { id }) => [
        { type: "DriverOnShift", id: String(id) },
        { type: "DriverOnShift", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListDriverOnShiftQuery,
  useListTruckDriverOnShiftsQuery,
  useCreateDriverOnShiftMutation,
  useUpdateDriverOnShiftMutation,
  useCompleteDriverOnShiftMutation,
  useForceCompleteDriverOnShiftMutation,
  useCancelDriverOnShiftMutation,
  useApproveDriverOnShiftMutation,
  useDriverOnShiftExistsQuery,
  useLazyDriverOnShiftExistsQuery,
  useLazyGetDriverOnShiftByIdQuery,
  useGetDriverOnShiftByIdQuery,
} = driverOnShiftGrpc;
